import { render, staticRenderFns } from "./ad-click-stats.vue?vue&type=template&id=0f60d6d6&scoped=true"
import script from "./ad-click-stats.vue?vue&type=script&lang=ts"
export * from "./ad-click-stats.vue?vue&type=script&lang=ts"
import style0 from "./ad-click-stats.vue?vue&type=style&index=0&id=0f60d6d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f60d6d6",
  null
  
)

export default component.exports